import { Box,  CircularProgress, Grid, Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { portal_config } from '../../portal.config';
import { formatAmount, replaceParamTranslation } from '../../utils/util';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import TooltipComponent from '../../components/Tooltip';


export default function WalletSection(props) {
    const { showLoadWallet, showLoadTierProgress, showLoadServices, mrrService, wallet, tier_progress, rewardTieringSupported, walletCurrency, isGuest } = props;
    const { palette } = useTheme();
    const { t } = useTranslation();
    const businessBalance = wallet ? dataUtil.getBalanceByType(wallet.balances, true) : null;
    const organisationName = businessBalance && businessBalance.organisation ? businessBalance.organisation.name : "";

    let sections = 2;
    if(rewardTieringSupported && tier_progress && tier_progress.current_color){
        sections++;
    }
    if(mrrService){
        sections++;
    }

    return (
        <Box>
            <Grid xs={12} item container direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={0.5}>
                {!portal_config.isDisableWalletBalance && 
                    <Grid xs={12 / sections} item container justifyContent={'center'} alignItems={'center'} borderRight={1} borderColor={palette.border.main}>
                        <Stack textAlign={'center'}>
                            {showLoadWallet ? 
                                <center><CircularProgress size={'1rem'} /></center> 
                                : 
                                (isGuest ?
                                    <Typography variant='h3' marginTop={0.5} sx={{ wordBreak: 'break-word' }}>
                                        {"N/A"}
                                    </Typography> : 
                                    <Typography variant='h3' marginTop={0.5} sx={{ wordBreak: 'break-word' }}>
                                        {walletCurrency}{wallet && wallet.total_open ? formatAmount(wallet.total_open, portal_config.isFormatDecimalBalance) : "0.00"}
                                    </Typography>
                                )
                            }
                            <Typography variant='subtitle2'>{t('open_money')}</Typography>
                            {/* Centering the tooltip along with the text */}
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
                                <TooltipComponent 
                                    id="wallet_tooltip_open"
                                    content={replaceParamTranslation(t('tooltip_wallet_blance'), [organisationName])}
                                />
                            </Stack>
                        </Stack>
                    </Grid>
                }
                
                {!portal_config.isDisableWalletBalance && 
                    <Grid xs={12 / sections} item container justifyContent={'center'} alignItems={'center'} borderRight={((rewardTieringSupported && tier_progress && tier_progress.current_color) || mrrService) ? 1 : 0} borderColor={palette.border.main}>
                        <Stack textAlign={'center'}>
                            {showLoadWallet ? 
                                <center><CircularProgress size={'1rem'} /></center> 
                                : 
                                (isGuest ?
                                    <Typography variant='h3' marginTop={0.5} sx={{ wordBreak: 'break-word' }}>
                                        {"N/A"}
                                    </Typography> : 
                                    <Typography variant='h3' marginTop={0.5} sx={{ wordBreak: 'break-word' }}>
                                        {walletCurrency}{wallet && wallet.total_commerce ? formatAmount(wallet.total_commerce, portal_config.isFormatDecimalBalance) : "0.00"}
                                    </Typography>
                                )
                            }
                            <Typography variant='subtitle2'>{t('commerce_pocket')}</Typography>
                            {/* Centering the tooltip along with the text */}
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
                                <TooltipComponent 
                                    id="wallet_tooltip"
                                    content={replaceParamTranslation(t('tooltip_wallet_business_commerce'), [organisationName])}
                                />
                            </Stack>
                        </Stack>
                    </Grid>
                }
                
                {rewardTieringSupported && tier_progress && tier_progress.current_color && 
                    <Grid xs={12 / sections} item container justifyContent={'center'} alignItems={'center'} borderRight={mrrService ? 1 : 0} borderColor={palette.border.main}>
                        <Stack textAlign={'center'}>
                            {showLoadTierProgress ? 
                                <center><CircularProgress size={'1rem'} /></center> 
                                : 
                                <Typography onClick={() => props.setShowRewardTier(true)} sx={{cursor:'pointer'}} variant='h3' marginTop={0.5} style={tier_progress.current_color ? { color: tier_progress.current_color } : undefined}>
                                    {tier_progress.current_name}
                                </Typography>
                            }
                            <Typography variant='subtitle2'>{t('tier')}</Typography>
                        </Stack>
                    </Grid>
                }
        
                {mrrService && 
                    <Grid xs={12 / sections} item container justifyContent={'center'} alignItems={'center'}>
                        <Stack textAlign={'center'}>
                            {showLoadServices ? 
                                <center><CircularProgress size={'1rem'} /></center> 
                                : 
                                <Typography variant='h3' marginTop={0.5}>
                                    {mrrService ? mrrService.product_name : undefined}
                                </Typography>
                            }
                            <Typography variant='subtitle2'>{t('subscriptions_title')}</Typography>
                        </Stack>
                    </Grid>
                }
            </Grid>
        </Box>
        )
}